import React from 'react';
import { Box } from '@mui/material';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  VideoLayout,
  SlideTitle,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const VideoSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  videoUrl,
  videoSubtitles,
  langCode,
  uiLocale = 'en-US',
}) => {
  const subtitleUrl = videoSubtitles || slide?.IntroVideoVtt || slide?.IntroVideoSrt;
  const resolvedVideoUrl = videoUrl || slide?.VideoUrl || slide?.IntroVideo;

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  const renderVideoPlayer = () => {
    if (!resolvedVideoUrl) return null;
    return (
      <Box
        sx={{
          width: '100%',
          maxWidth: '900px',
          aspectRatio: '16/9',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          backgroundColor: '#000',
        }}
      >
        <video
          controls
          crossOrigin="anonymous"
          controlsList="nodownload"
          style={{
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'contain',
          }}
          src={resolvedVideoUrl}
        >
          {tUi('slide.video.notSupported', uiLocale)}
          {subtitleUrl && (
            <track
              kind="subtitles"
              src={subtitleUrl}
              srcLang={langCode || 'en'}
              label={langCode ? langCode.toUpperCase() : 'English'}
              default={true}
            />
          )}
        </video>
      </Box>
    );
  };

  return (
    <VideoLayout>
      {isEditMode ? (
        <>
          {renderVideoPlayer()}
          <CombinedEditableSection
            slide={slide}
            isEditMode={isEditMode}
            slideEdits={slideEdits}
            showEnglishContent={showEnglishContent}
            onSave={onSaveEdit}
            onReset={onResetEdit}
            onCancel={onCancelEdit}
            TitleComponent={SlideTitle}
            ContentComponent={PointText}
            titleExtraProps={{ style: { textAlign: 'center' } }}
          />
        </>
      ) : (
        <>
          {slide?.SlideTitle && (
            <SlideTitle style={{ textAlign: 'center' }}>
              {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
            </SlideTitle>
          )}
          {renderVideoPlayer()}
          {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
        </>
      )}
    </VideoLayout>
  );
};

export default VideoSlide;
